<div class="main">
  <div class="loader" *ngIf="showLoader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
    <div class="left">
        <div class="header">
            <div class="label">{{'SHIPMENT_MAP_VIEW.title' | translate}}</div>
            <div class="search">
                <input type="text" mat-input class="searchInput" [(ngModel)]="filterSIN" (keyup)="searchFilter(filterSIN, 'SIN');" placeholder="Search SIN...">
                <i class="material-icons" (click)="searchCleared = true;clearFilter();">cancel</i>
            </div>
            <div class="filters">
              <div class="date">{{readableTime(shipmentFilters.from)}}</div>
              <i class="material-icons datePicker" (click)="picker.open()">date_range</i>
              <mat-datepicker #picker></mat-datepicker>

              <input  class="hidden" (dateChange)="searchFilter($event, 'date')" [matDatepicker]="picker">
            </div>
            <div class="helper">
              <!-- <app-help></app-help> -->
            </div>
        </div>
        <div class="summaryBox">
            <div class="summary">
                <div class="icon">
                    <img class="imgIcon" src="assets/Pending.svg" alt="">
                </div>
                <div class="status">
                    {{'SHIPMENT_MAP_VIEW.pending' | translate}}
                </div>
                <div class="value" style="color:#1584ee">
                    {{shipmentCounts.pending}}
                </div>
            </div>
            <div class="summary">
                <div class="icon">
                    <img class="imgIcon" src="assets/InTransit.svg" alt="">
                </div>
                <div class="status">
                    {{'SHIPMENT_MAP_VIEW.inTransit' | translate}}
                </div>
                <div class="value" style="color:#c4600b">
                    {{shipmentCounts.intransit}}
                </div>
            </div>
            <div class="summary">
                <div class="icon">
                    <img class="imgIcon" src="assets/Completed.svg" alt="">
                </div>
                <div class="status">
                    {{'SHIPMENT_MAP_VIEW.completed' | translate}}
                </div>
                <div class="value" style="color:#188c06">
                    {{shipmentCounts.completed}}
                </div>
            </div>
            <div class="summary" style="border-right: none;">
                <div class="icon">
                    <img class="imgIcon" src="assets/Cancelled.svg" alt="">
                </div>
                <div class="status">
                    {{'SHIPMENT_MAP_VIEW.cancel' | translate}}
                </div>
                <div class="value" style="color:#d2191c;">
                    {{shipmentCounts.cancelled}}
                </div>
            </div>
        </div>

        <div class="ind-shipments" infiniteScroll [infiniteScrollDistance]="2" [scrollWindow]="false"
            [infiniteScrollThrottle]="50" (scrolled)="onScroll();">

            <mat-accordion>
              <mat-expansion-panel (afterExpand)="selectShipment(shipment);" style="font-family: 'Muli', sans-serif;" class="shipment"  *ngFor="let shipment of shipmentsArray; let i =index;">
                <mat-expansion-panel-header  style="height: 100px; font-family: Muli, sans-serif;">
                  <div class="shipmentHeading">
                    <div class="shipmentNumber">
                      <div class="sin"> 
                        <div> {{shipment.sin}} 
                          <img class="statusIcons" [hidden]="(!shipment.notAccepted || shipment.driverName == '--') || (shipment.hasSmartPhone)" src="assets/Accepted-grey.svg" alt=""> 
                          <img class="statusIcons" [hidden]="(shipment.notAccepted)" src="assets/Accepted.svg" alt="">  
                          <img  class="statusIcons" src="assets/sim-tracking.svg" alt="" *ngIf="shipment.simTracking.isConsent || shipment.tracking">  
                          <!-- <img class="statusIcons" src="assets/sim-tracking-red.svg" alt=""> -->
                        </div>
                        <div class="status">
                          <div class="status-img">
                              <img [src]="shipment.icon_url" style="height:20px">
                          </div>
                          <div class="status-text" [ngClass]="{'assigned':shipment.status == 'Assigned','completed':shipment.status == 'Completed','cancelled':shipment.status == 'Cancelled', 'pending': shipment.status == 'Pending', 'inTransit':shipment.status == 'In Transit','towardsPickup':shipment.status == 'Towards Pickup','atPickup':shipment.status == 'At Pickup','atDelivery':shipment.status == 'At Delivery','accepted': shipment.status == 'Accepted'}">{{shipment.status}}</div>
                        </div>
                      <!-- <sup class="notAccepted" *ngIf="shipment.notAccepted && shipment.driverName != '--'">{{'SHIPMENT_MAP_VIEW.notAccepted' | translate}}</sup> -->
                      </div>
                      <div class="date">
                        <div> {{shipment.scheduledDate}} </div>
                        <div class="row-detail">
                          <span *ngFor="let material of shipment.material; let i = index;">
                            {{material.name}}<span *ngIf="shipment.material.length > 1 && i != shipment.material.length - 1">, </span>
                          </span>
                        </div>
                      </div>
                    </div>


                    <div class="driverDetails">
                      <div class="name"> 
                        <i class="material-icons">
                          account_circle
                        </i>
                        <span> {{shipment.driverName}} </span></div>
                      <div class="number">
                        <i class="material-icons">
                          phone
                        </i>
                        <span>{{shipment.driverMobile}} </span> </div>
                    </div>
                    <div class="driverDetails">
                      <div class="name"> 
                        <i class="material-icons">
                          local_shipping
                        </i>
                        <span> {{shipment.vehicleType}} </span></div>
                      <div class="number"> 
                        <i class="material-icons">
                          local_play
                        </i>
                        <span> {{shipment.vehicleNumber}} </span></div>
                    </div>
                    <div class="buttons">
                      <div class="button">
                        <mat-select (click)="$event.stopPropagation()" [placeholder]="'SHIPMENT_MAP_VIEW.actions' | translate">
                          <mat-option (click)="openViewModal(shipment);">
                            <img style="width: 16px;position: relative;top: 3px;" src="assets/icon-view.svg" alt="">  {{'SHIPMENT_MAP_VIEW.view' | translate}}
                          </mat-option >
                          <mat-option [disabled]="true">
                            <img style="width: 16px;position: relative;top: 3px;" src="assets/icon-edit.svg" alt="">  {{'SHIPMENT_MAP_VIEW.edit' | translate}}
                          </mat-option>
                          <mat-option [disabled]="true">
                            <img style="width: 16px;position: relative;top: 3px;" src="assets/icon-cancel-red.svg" alt="">  {{'SHIPMENT_MAP_VIEW.cancel' | translate}}
                          </mat-option>
                          <mat-option [disabled]="(!shipment.notAccepted || shipment.driverName == '--') || (shipment.hasSmartPhone)" (click)="(!shipment.notAccepted || shipment.driverName == '--') || (shipment.hasSmartPhone) ? '': acceptDia(shipment);" >
                            <img style="width: 16px;position: relative;top: 3px;" src="assets/Accepted.svg" alt="">  {{'SHIPMENT_MAP_VIEW.accept' | translate}}
                          </mat-option>
                          <mat-option *ngIf="showTracking"  (click)="(shipment.inTransit) ? openSubscribe(shipment) : ';'" [disabled]="(!shipment.inTransit)">
                            <img style="width: 16px;position: relative;top: 3px;" src="assets/tracking.svg" alt="">  {{'SHIPMENT_MAP_VIEW.tracking' | translate}}
                          </mat-option>
                          <mat-option [disabled]="shipment.status == 'Completed'" (click)="(shipment.status != 'Completed') ? warningDialog(shipment) : ';'">
                            <img style="width: 16px;position: relative;top: 3px;" src="assets/Assign.svg" alt="">   {{(shipment.driverName != '--') ? ('SHIPMENT_MAP_VIEW.reassign' | translate) : ('SHIPMENT_MAP_VIEW.assign_driver' | translate)}}
                          </mat-option>
                          <mat-option [disabled]="shipment.status != 'Completed' || shipment.disableGenerateInvoice || shipment.isCarrierShipment" (click)="( shipment.status == 'Completed' && !shipment.disableGenerateInvoice && !shipment.isCarrierShipment ) ? generateFreight(shipment) : ''">
                            <img style="width: 16px;position: relative;top: 3px;" src="assets/generate.svg" alt="">  {{'SHIPMENT_DASHBOARD.generate_bill' | translate}}
                          </mat-option>
                          <mat-option [disabled]="!shipment.inTransit" (click)="$event.stopPropagation(); shipment.inTransit ? share(shipment) : ''">
                            <img style="width: 16px;position: relative;top: 3px;" src="assets/share.svg" alt="">  {{'SHIPMENT_MAP_VIEW.share' | translate}}
                          </mat-option>
                          <mat-option [disabled]="!shipment.inTransit" (click)="$event.stopPropagation(); shipment.inTransit ? sendEmail(shipment) :''">
                            <img style="width: 16px;position: relative;top: 3px;" src="assets/mailround.svg" alt="">  {{'SHIPMENT_MAP_VIEW.mail' | translate}}
                          </mat-option>
                          <mat-option (click)="openViewModal(shipment, 3)">
                            <img style="width: 16px;position: relative;top: 3px;" src="assets/upload.svg" alt="">  {{'SHIPMENT_MAP_VIEW.upload_epod' | translate}}
                          </mat-option>
                          <mat-option (click)="openViewModal(shipment, 3)">
                            <img style="width: 16px;position: relative;top: 3px;" src="assets/request-ePOD.svg" alt="">  {{'SHIPMENT_MAP_VIEW.requestEpod' | translate}}
                          </mat-option>
                          <mat-option *ngIf="(shipment.status != 'Completed')" (click)="(shipment.status !== 'Completed')? completeShipment(shipment) : '';" >
                            <img style="width: 16px;position: relative;top: 3px;" src="assets/Completed.svg" alt="">  {{'SHIPMENT_MAP_VIEW.complete_shipment' | translate}}
                          </mat-option>
                        </mat-select>

                      </div>
                    </div>
                  </div>
                </mat-expansion-panel-header>
                
                <mat-divider></mat-divider>
                <div class="locationDetails">
                  <mat-vertical-stepper [selected]="shipment.selectedOrderAllLocationsData.length+10" [linear]="true" #stepper>
                      <mat-step [label]="locStep._id" [state]="locStep._id" *ngFor="let locStep of shipment.selectedOrderAllLocationsData;let i = index">
                        <ng-template matStepLabel>{{locStep.location.name}}</ng-template>
                        <div class="areaDetails">
                          {{locStep.location.area}}<br>
      
                          <span class="dateTime">
                            <i class="material-icons">date_range</i>
                            {{changeDateFormat(locStep.date_time)}}
                          </span>
                        </div>
                      </mat-step>
                      <ng-template  *ngFor="let locStep of shipment.from;let i = index"  [matStepperIcon]="locStep._id">
                        <span class="pick-icon" style="font-size: 13px;">P{{i+1}}</span>
                      </ng-template>
                      <ng-template *ngFor="let locStep of shipment.to;let i = index" [matStepperIcon]="locStep._id">
                        <span class="drop-icon" style="font-size: 13px;">D{{i+1}}</span>
                      </ng-template>
      
                    </mat-vertical-stepper>
              </div>

              </mat-expansion-panel>
            </mat-accordion>


            <!-- <div class="shipment" [ngClass]="{selectedShipment: shipment._id == selectedShipment._id}" *ngFor="let shipment of shipmentsArray" (click)="selectShipment(shipment);">
                <div class="shipmentHeader">
                    <div class="title">#{{shipment.sin}}</div>
                    <div class="time">{{shipment.scheduledDate}}</div>
                </div>
                <div class="customerDetails">
                    <div class="row">
                        <div class="row-title">
                            {{'SHIPMENT_MAP_VIEW.driver_name' | translate}}
                        </div>
                        <div class="row-detail">
                            {{shipment.driverName}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-title">
                            {{'SHIPMENT_MAP_VIEW.driver_mobile' | translate}}
                        </div>
                        <div class="row-detail">
                            {{shipment.driverMobile}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-title">
                            {{'SHIPMENT_MAP_VIEW.vehicle' | translate}}
                        </div>
                        <div class="row-detail">
                            {{shipment.vehicleType}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-title">
                            {{'SHIPMENT_MAP_VIEW.vehicle_number' | translate}}
                        </div>
                        <div class="row-detail">
                            {{shipment.vehicleNumber}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-title">
                            {{'SHIPMENT_MAP_VIEW.material' | translate}}
                        </div>
                        <div class="row-detail" *ngFor="let material of shipment.material">
                            {{shipment.material}}
                        </div>
                    </div>
                </div>
                <mat-divider></mat-divider>
                <div class="locationDetails">
                    <mat-vertical-stepper [selected]="shipment.selectedOrderAllLocationsData.length+10" [linear]="true" #stepper>
                        <mat-step [label]="locStep._id" [state]="locStep._id" *ngFor="let locStep of shipment.selectedOrderAllLocationsData;let i = index">
                          <ng-template matStepLabel>{{locStep.location.name}}</ng-template>
                          <div class="areaDetails">
                            {{locStep.location.area}}<br>
        
                            <span class="dateTime">
                              <i class="material-icons" style="color: #666;margin-right: 6px;margin-top: -5px;margin-left: -2px;">date_range</i>
                              {{changeDateFormat(locStep.date_time)}}
                            </span>
                          </div>
                        </mat-step>
                        <ng-template  *ngFor="let locStep of shipment.from;let i = index"  [matStepperIcon]="locStep._id">
                          <span class="pick-icon" style="font-size: 13px;">P{{i+1}}</span>
                        </ng-template>
                        <ng-template *ngFor="let locStep of shipment.to;let i = index" [matStepperIcon]="locStep._id">
                          <span class="drop-icon" style="font-size: 13px;">D{{i+1}}</span>
                        </ng-template>
        
                      </mat-vertical-stepper>
                </div>
                <mat-divider></mat-divider>
                <div class="actions">
                    <div class="status">
                        <div class="status-img">
                            <img [src]="shipment.icon_url" height="25px">
                        </div>
                        <div class="status-text" [ngClass]="{'assigned':shipment.status == 'Assigned','completed':shipment.status == 'Copmleted','cancelled':shipment.status == 'Cancelled', 'pending': shipment.status == 'Pending', 'inTransit':shipment.status == 'In Transit'}">{{shipment.status}}</div>
                    </div>
                    <div class="buttons">
                        <div class="button">
                          <mat-select (click)="$event.stopPropagation()" [placeholder]="'SHIPMENT_MAP_VIEW.actions' | translate">
                            <mat-option (click)="openViewModal(shipment);">
                              <img style="width: 16px;position: relative;top: 3px;" src="assets/icon-view.svg" alt="">  {{'SHIPMENT_MAP_VIEW.view' | translate}}
                            </mat-option >
                            <mat-option>
                              <img style="width: 16px;position: relative;top: 3px;" src="assets/icon-edit.svg" alt="">  {{'SHIPMENT_MAP_VIEW.edit' | translate}}
                            </mat-option>
                            <mat-option>
                              <img style="width: 16px;position: relative;top: 3px;" src="assets/icon-cancel-red.svg" alt="">  {{'SHIPMENT_MAP_VIEW.cancel' | translate}}
                            </mat-option>
                            <mat-option [disabled]="(!shipment.notAccepted || shipment.driverName == '--') || (shipment.hasSmartPhone)" (click)="acceptDia(shipment);" >
                              <img style="width: 16px;position: relative;top: 3px;" src="assets/Accepted.svg" alt="">  {{'SHIPMENT_MAP_VIEW.accept' | translate}}
                            </mat-option>
                            <mat-option (click)="openSubscribe(shipment);">
                              <img style="width: 16px;position: relative;top: 3px;" src="assets/Accepted.svg" alt="">  Tracking
                            </mat-option>
                            <mat-option [disabled]="shipment.status == 'Completed'" (click)="(shipment.status != 'Completed') ? warningDialog(shipment) : ';'">
                              <img style="width: 16px;position: relative;top: 3px;" src="assets/Assign.svg" alt="">   {{(shipment.driverName != '--') ? ('SHIPMENT_MAP_VIEW.reassign' | translate) : ('SHIPMENT_MAP_VIEW.assign_driver' | translate)}}
                            </mat-option>
                            <mat-option (click)="$event.stopPropagation(); share(shipment);">
                              <img style="width: 16px;position: relative;top: 3px;" src="assets/share.svg" alt="">  {{'SHIPMENT_MAP_VIEW.share' | translate}}
                            </mat-option>
                            <mat-option (click)="openViewModal(shipment, 3)">
                              <img style="width: 16px;position: relative;top: 3px;" src="assets/upload.svg" alt="">  {{'SHIPMENT_MAP_VIEW.upload_epod' | translate}}
                            </mat-option>
                            <mat-option (click)="openViewModal(shipment, 3)">
                              <img style="width: 16px;position: relative;top: 3px;" src="assets/request-ePOD.svg" alt="">  {{'SHIPMENT_MAP_VIEW.requestEpod' | translate}}
                            </mat-option>
                            <mat-option (click)="completeShipment(shipment);" >
                              <img style="width: 16px;position: relative;top: 3px;" src="assets/Completed.svg" alt="">  {{'SHIPMENT_MAP_VIEW.complete_shipment' | translate}}
                            </mat-option>
                          </mat-select>

                        </div>
                      </div>
                </div>
            </div> -->
        </div>
    </div>

    <div class="right">

      <div class="mapButtons" *ngIf="showMapButtons">
        <div class="submitButton" *ngIf="gpsMode">
          <div class="button" [ngStyle]="{'background-color': gpsMode? '#631d50':'#fff' , 'color': gpsMode? '#fff' : '#000'}" (click)="simMode = false; appMode = false;gpsMode = true;drawPath();" >
            <img *ngIf="!gpsMode" src="assets/gps.svg" alt=""><img *ngIf="gpsMode" src="assets/gps-white.svg" alt=""><span class="label">GPS</span>
          </div>
        </div>
        <div class="submitButton" *ngIf="simMode">
            <div class="button"   [ngStyle]="{'background-color': simMode? '#631d50':'#fff' , 'color': simMode? '#fff' : '#000'}"
                (click)="simMode = true; appMode = false;gpsMode = false;drawPath();">
                <img *ngIf="!simMode" src="assets/sim.svg" alt=""><img *ngIf="simMode" src="assets/sim-white.svg" alt=""><span class="label">Sim</span>
        
            </div>
        </div>
        <div class="submitButton" *ngIf="appMode">
            <div class="button"  [ngStyle]="{'background-color': appMode? '#631d50':'#fff' , 'color': appMode? '#fff' : '#000'}" (click)="simMode = false; appMode = true;gpsMode = false;drawPath();">
              <img *ngIf="!appMode" src="assets/app.svg" alt=""><img *ngIf="appMode" src="assets/app-white.svg" alt=""><span class="label">App</span>
        
            </div>
        </div>
      </div>

      <div class="estimatedDetails" *ngIf="showMapButtons && selectedShipment.status === 'In Transit' ">
        <div>
          {{'SHIPMENTDETAILS.remaining_distance' | translate}}: {{(selectedShipment.remainingDistance) || 'N/A'}}
        </div>
        <div>
          {{'SHIPMENTDETAILS.remaining_time' | translate}}: {{(selectedShipment.remainingTime) || 'N/A'}}
        </div>
      </div>

        <div class="shipmentMap" id="shipmentMap">

        </div>
    </div>
</div>


<ng-template #warning>
  <div class="dialogMain">
    <div class="section">
      <div class="header">
        <div class="label">
          {{'SHIPMENT_MAP_VIEW.warning' | translate}}<i class="material-icons" (click)="warningRef.close(false);">clear</i>
        </div>
      </div>
      <div class="text">
        {{'SHIPMENT_MAP_VIEW.warningText' | translate}}
      </div>
      <div class="submitButton">
        <div class="button" (click)="warningRef.close(true);">
          {{'SHIPMENT_MAP_VIEW.ok' | translate}}
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #acceptDialog>
  <div class="dialogMain">
    <div class="section">
      <div class="header">
        <div class="label">
          {{'SHIPMENT_MAP_VIEW.accept' | translate}}<i class="material-icons" (click)="acceptRef.close(false);">clear</i>
        </div>
      </div>
      <div class="text">
        {{'SHIPMENT_MAP_VIEW.acceptText' | translate}}
      </div>
      <div class="submitButton">
        <div class="button" (click)="acceptRef.close(true);">
          {{'SHIPMENT_MAP_VIEW.ok' | translate}}
        </div>
      </div>
    </div>
  </div>
</ng-template>